
import React from 'react';
import { Button } from '@/components/ui/button';
import { BrandButton, BrandText, BrandGradient } from '@/components/ui/brand';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden">
      <BrandGradient
        variant="primary"
        intensity="light"
        className="absolute inset-0 z-0"
      />
      
      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="mb-6 animate-fade-in">
            <BrandText as="h1" size="4xl" weight="bold" className="mb-4 leading-tight">
              Hire AI Staff to Automate Your Business
            </BrandText>
            <BrandText size="xl" muted className="mb-8">
              VirtuStaff.ai provides intelligent AI assistants that learn your brand voice and automate routine tasks.
            </BrandText>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4 animate-slide-up">
            <Button
              size="lg"
              onClick={() => navigate('/onboarding')}
              className="bg-brand text-white font-semibold rounded-xl px-8"
            >
              Get Started <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/demo')}
              className="border-brand text-brand rounded-xl px-8"
            >
              See It In Action
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
